import {
    ModalBody,
    Modal,
    ModalHeader,
    NavLink
} from "reactstrap";
import { useEffect, useState } from "react";
import { useStore } from "../../utilities/appStore";
import dcgLogo from "../../assets/img/brand/dcg_logo_header.png";
import SpinnerWheel from "../../components/SpinnerWheel/SpinnerWheel";
import { useProcessInviteMutation } from "../../utilities/mutations/useProcessInviteMutation";
import { useAuth } from "react-oidc-context";

const InviteProcessingPage = () => {
    const auth = useAuth();
    const config = useStore((state) => state.Configuration);
    const [inviteInfo, setInviteInfo] = useState(null);
    useEffect(() => {
        if (!auth.isLoading && auth.user?.state) {
            try {
                const decoded = decodeURIComponent(auth.user.state);
                const parsed = JSON.parse(decoded);
                setInviteInfo(parsed);
            } catch (e) {
                console.error("Failed to parse state:", e);
            }
        }
    }, [auth]);

    const successCall = (response) => {
        const email = encodeURIComponent(auth.user.profile.email);
        const url = `${config.dcgUserPortalUrl}?email=${email}`;
        window.location.href = url;
    };
    const { mutateAsync: process, error: getError } = useProcessInviteMutation();
    const errorMessage = getError?.response?.data?.message;
    useEffect(() => {
        if (inviteInfo?.sharedCode) {
            process({ sharedCode: inviteInfo?.sharedCode }, { onSuccess: successCall })
        }
        
    }, [inviteInfo]);
    return (

        <Modal className="w-50" isOpen={true}>
            <ModalHeader style={{ display: 'unset' }}><div style={{ textAlign: "center" }}><img src={dcgLogo} alt="dcg logo" /></div></ModalHeader>
            <ModalBody className="text-center">

                {!getError &&
                    < div >

                        <SpinnerWheel shouldNavigate={false} />
                        <p className="display-4">We are processing your invite</p>
                        <p>Please do not leave or close this page</p>

                    </div>}

                {getError &&
                    <div>
                        <p className="text-danger">{errorMessage}</p>
                        <NavLink href={config.dcgUserPortalUrl}>DCG portal</NavLink>
                    </div>}
            </ModalBody>
        </Modal>
    );
}

export default InviteProcessingPage;